export enum CustomerActionTypes {
    API_RESPONSE_SUCCESS = '@@customer/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@customer/API_RESPONSE_ERROR',
    GET_CUSTOMERS = '@@customer/GET_CUSTOMERS',
    GET_CUSTOMER_DETAILS = '@@customer/GET_CUSTOMER_DETAILS',
    ADD_CUSTOMER = '@@customer/ADD_CUSTOMER',
    UPDATE_CUSTOMER = '@@customer/UPDATE_CUSTOMER',
    DELETE_CUSTOMER = '@@customer/DELETE_CUSTOMER',
    CLEAR_CUSTOMERS = '@@customer/CLEAR_CUSTOMERS',
}
